import { createContext, useContext } from 'react';
import { IPreviewTableFilters } from '../../types.ts';

type MyContextType = {
  filters: IPreviewTableFilters;
  handleFilterChange: (filters: Partial<IPreviewTableFilters>) => void;
  handleClearAll: () => void;
  isFiltersCardOpen: boolean;
  handleOpenFiltersCard: () => void;
  handleCloseFiltersCard: () => void;
  handleToggleFiltersCard: () => void;
};

export const PreviewContext = createContext<MyContextType | null>(null);

export const usePreviewContext = () => {
  const context = useContext(PreviewContext);
  if (!context) {
    throw new Error(
      'The usePreviewContext hook must be used within a PreviewContextProvider.',
    );
  }
  return context;
};
